import React from 'react';
import './questioncard.scss';


function QuestionCard(props) {
    return (
        <div className="quesition-card">
            <div className="title">
                <span>
                    <img src="./images/question.svg" />
                </span>
                {props.data.title}
            </div>
            <div className="desc">{props.data.desc}</div>
        </div>
    );
}

export default QuestionCard;
